import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const STORAGE_KEY = 'casapooch_lang';

const resources = {
  fr: {
    translation: {
      meta: {
        title: 'Casapooch — Toilettage canin de luxe à Montréal',
        description: 'Casapooch, salon de toilettage et de bien-être canin haut de gamme au cœur du Mile-Ex, à Montréal. Votre toutou, notre passion.',
        locale: 'fr_CA'
      },
      pageTitles: {
        about: 'À propos',
        services: 'Nos services',
        blog: 'Rapport CP',
        events: 'Événements',
        book: 'Réserver',
        contact: 'Contact',
        gallery: 'Galerie',
        admin: 'Admin'
      },
      pageDescriptions: {
        about: 'Découvrez l’histoire de Casapooch, fondé par Jessica Amber Rossi et Pasqualino Dachille et inspiré par leurs chiens Hunter et Brio.',
        services: 'Coupe signature de race, toilettage complet, bain et retouches, soins des griffes : découvrez nos services de toilettage canin de luxe à Montréal.',
        blog: 'Conseils de toilettage, astuces bien-être et nouvelles de la communauté Casapooch.',
        events: 'Événements, ateliers et rencontres pour les amoureux des chiens chez Casapooch, à Montréal.',
        book: 'Réservez en ligne le rendez-vous de toilettage de votre chien chez Casapooch, à Montréal.',
        contact: 'Contactez Casapooch : 70, rue Jean-Talon Ouest, Montréal. Ouvert du mardi au samedi, de 9 h à 18 h.',
        gallery: 'Découvrez les plus récentes transformations de Casapooch sur Instagram.'
      },
      nav: {
        home: 'Accueil',
        about: 'À propos',
        services: 'Services',
        gallery: 'Galerie',
        blog: 'Rapport CP',
        events: 'Événements',
        book: 'Réserver',
        contact: 'Contact',
        bookNow: 'Réserver',
        langToggle: 'Switch to English',
        openMenu: 'Ouvrir le menu',
        closeMenu: 'Fermer le menu'
      },
      home: {
        heroTitle: 'Votre toutou, notre passion',
        heroSubtitle: 'Toilettage et bien-être canin de luxe au cœur de Montréal',
        heroCta: 'Réservez votre visite',
        servicesLabel: 'Nos services',
        servicesTitle: 'Chouchoutez votre toutou',
        services: {
          bath: { title: 'Bain & brossage', desc: 'Formules spa hypoallergéniques' },
          styling: { title: 'Coupe & stylisme', desc: 'Coupes de précision selon la race' },
          wellness: { title: 'Soins bien-être', desc: 'Soins complets des pattes et du pelage' },
          seasonal: { title: 'Soins saisonniers', desc: 'Entretien du pelage hiver et été' }
        },
        viewAll: 'Voir tous les services',
        storyLabel: 'Notre histoire',
        storyTitle: 'Là où l’expertise rencontre l’affection',
        storyText: 'Fondé par Jessica Amber Rossi et Pasqualino Dachille, Casapooch est né de l’amour pour leurs chiens adorés, Hunter et Brio. Chaque séance de toilettage est réalisée avec précision, patience et une affection sincère.',
        learnMore: 'En savoir plus sur nous',
        reviewsLabel: 'Avis',
        reviewsTitle: 'Ce que disent nos clients',
        reviewsMeta: '{{rating}} sur 5 — {{count}} avis sur Google',
        teamLabel: 'L’équipe',
        teamTitle: 'Rencontrez les fondateurs',
        teamSubtitle: 'Jessica & Pasqualino avec Hunter & Brio',
        readStory: 'Lire notre histoire',
        ctaTitle: 'Prêt à chouchouter votre toutou?',
        ctaText: 'Prenez rendez-vous et offrez à votre compagnon l’expérience spa de luxe qu’il mérite.',
        ctaButton: 'Prendre rendez-vous',
        alts: {
          jessica: 'Jessica Amber Rossi – fondatrice principale',
          together: 'Jessica et Pasqualino chez Casapooch',
          brio: 'Jessica et Pasqualino avec Brio',
          hunter: 'Jessica et Pasqualino avec Hunter'
        }
      },
      transformations: {
        label: 'Transformations',
        title: 'Voyez la magie',
        before: 'Avant',
        after: 'Après',
        altBefore: '{{name}} avant',
        altAfter: '{{name}} après'
      },
      instagram: {
        label: 'Suivez-nous',
        title: '@lecasapooch',
        postAlt: 'Publication Instagram'
      },
      servicesPage: {
        overline: 'Nos services',
        title1: 'Toilettage de luxe',
        title2: '& bien-être',
        subtitle: 'Du stylisme adapté à la race aux soins de bien-être complets, découvrez nos services signature conçus pour chouchouter votre toutou avec expertise et affection.',
        ctaTitle: 'Prêt à réserver?',
        ctaText: 'Offrez à votre toutou l’expérience spa de luxe qu’il mérite. Réservez votre rendez-vous dès aujourd’hui.'
      },
      about: {
        overline: 'À propos de Casapooch',
        title: 'Là où l’expertise rencontre l’affection',
        mainFounder: 'Fondatrice principale',
        coFounder: 'Cofondateur',
        inspiration: 'L’inspiration',
        jessica: [
          'Jessica est le cœur et l’âme de Casapooch. Toiletteuse passionnée cumulant des années d’expérience, elle a fondé Casapooch avec une conviction simple : chaque chien mérite de se sentir choyé, aimé et beau.',
          'Maman dévouée de Hunter et Brio, Jessica offre la même attention maternelle à chaque toutou qui franchit nos portes. Son expertise en coupes adaptées à la race et son approche tout en douceur ont fait de Casapooch la destination de toilettage de luxe la plus fiable à Montréal.',
          'Des chiens de refuge anxieux aux chiens d’exposition choyés, Jessica voit chaque séance de toilettage comme une occasion de créer un lien de confiance et de transformer votre toutou avec précision, patience et une affection sincère.'
        ],
        pasqualino: [
          'Pasqualino est le cofondateur de Casapooch et le visionnaire derrière Casanova Barber & Salon. Son esprit entrepreneurial et son souci de l’excellence complètent parfaitement l’expertise de Jessica en toilettage.',
          'Papa de Hunter et Brio et mari de Jessica, Pasqualino apporte son sens des affaires et une passion commune pour la création d’espaces où les gens comme les animaux se sentent valorisés et bien traités. Son expérience dans l’hospitalité et le toilettage garantit à chaque client une expérience fluide et luxueuse chez Casapooch.',
          'Ensemble, Jessica et Pasqualino ont créé bien plus qu’un salon de toilettage : une communauté où les amoureux des chiens de Montréal savent que leurs toutous recevront les meilleurs soins, inspirés par l’amour qu’ils portent à Hunter et Brio.'
        ],
        dogs: [
          'Hunter, un golden retriever doux et loyal, est l’âme tranquille de la famille. Sa nature douce et sa patience ont inspiré l’atmosphère chaleureuse et sans stress de Casapooch. Chaque chien qui nous visite reçoit la même tendresse que Hunter à la maison.',
          'Brio, un goldendoodle fougueux et joueur, apporte l’énergie et la joie. Son pelage bouclé et son amour des séances de toilettage sont à l’origine même de l’idée de Casapooch. Brio nous rappelle chaque jour que le toilettage doit être une expérience positive et amusante pour chaque toutou.'
        ],
        community: 'Ancrage communautaire',
        rootedTitle: 'Enraciné à Montréal',
        communityContent: 'Situé au cœur du Mile-Ex et de la Petite-Italie, à Montréal, Casapooch est bien plus qu’un salon de toilettage : c’est un lieu de rassemblement pour les amoureux des chiens. Nous sommes fiers de servir des familles de partout à Montréal, y compris celles qui fréquentent les parcs Jarry et Dante avec leurs compagnons à quatre pattes.',
        values: {
          love: { title: 'Amour & soins', desc: 'Chaque chien reçoit la même affection et la même attention que nous offrons à Hunter et Brio.' },
          luxury: { title: 'Expérience de luxe', desc: 'Produits de qualité spa, environnement apaisant et service de boutique pour votre toutou.' },
          precision: { title: 'Précision experte', desc: 'Techniques de coupe et de toilettage adaptées à la race, perfectionnées au fil des années.' }
        },
        alts: {
          jessica: 'Jessica Amber Rossi – fondatrice principale de Casapooch',
          founders: 'Jessica Amber Rossi et Pasqualino Dachille – fondateurs de Casapooch',
          dogs: 'Hunter et Brio avec Jessica et Pasqualino chez Casapooch'
        }
      },
      testimonials: {
        reviews: [
          { text: 'Les meilleurs toiletteurs à Montréal! Ma chienne adoptée Hazel était calme et heureuse.', author: 'Kseniia M.' },
          { text: 'Excellents soins pour notre terrier de 14 ans — une patience et un savoir-faire incroyables.', author: 'Mrs Meadys' },
          { text: 'Notre toutou rentre toujours à la maison magnifique et heureux!', author: 'Sarah L.' }
        ]
      },
      booking: {
        overline: 'Prendre rendez-vous',
        title: 'Réservez la journée spa de votre chien',
        subtitle: 'Prenez rendez-vous directement ici',
        openInNew: 'Ouvrir dans un nouvel onglet',
        systemTitle: 'Système de réservation MoeGo',
        iframeTitle: 'Réservation en ligne',
        expectTitle: 'À quoi vous attendre',
        steps: {
          call: { title: 'Appel de confirmation', desc: 'Nous vous appellerons pour confirmer votre rendez-vous et discuter des besoins de votre toutou.' },
          spa: { title: 'Expérience spa', desc: 'Détendez-vous pendant que nous chouchoutons votre toutou avec un toilettage de luxe.' },
          happy: { title: 'Toutou heureux', desc: 'Récupérez votre chien magnifiquement toiletté, heureux et en pleine santé!' }
        },
        floatingTitle: 'Réservez votre journée spa',
        floatingSubtitle: 'Prenez rendez-vous ci-dessous',
        floatingOpen: 'Réserver un rendez-vous',
        floatingClose: 'Fermer'
      },
      contact: {
        overline: 'Contactez-nous',
        title: 'Visitez-nous',
        subtitle: 'Nous serions ravis d’avoir de vos nouvelles. Passez nous voir dans le Mile-Ex ou écrivez-nous.',
        getInTouch: 'Pour nous joindre',
        addressLabel: 'Adresse',
        phoneLabel: 'Téléphone',
        emailLabel: 'Courriel',
        address: '70, rue Jean-Talon Ouest, Montréal (Québec) H2R 2W7',
        phone: '514-272-9016',
        email: 'woof@lecasapooch.com',
        hours: 'Heures d’ouverture',
        hoursSchedule: 'Mardi – samedi : 9 h à 18 h',
        closed: 'Fermé le dimanche et le lundi',
        mapTitle: 'Emplacement de Casapooch',
        form: {
          title: 'Contactez-nous',
          name: 'Nom',
          email: 'Courriel',
          message: 'Message',
          send: 'Envoyer',
          success: 'Merci! Nous vous répondrons bientôt.',
          error: 'Une erreur s’est produite. Veuillez réessayer.'
        }
      },
      footer: {
        tagline: 'Votre toutou, notre passion.',
        quickLinks: 'Liens rapides',
        contact: 'Contact',
        addressLine1: '70, rue Jean-Talon Ouest',
        addressLine2: 'Montréal (Québec) H2R 2W7',
        rights: '© 2026 Casapooch. Tous droits réservés.'
      },
      blog: {
        title: 'Blogue & actualités',
        heading: 'Conseils, histoires & nouvelles',
        subtitle: 'Conseils d’experts en toilettage, astuces bien-être et nouvelles de la communauté Casapooch.',
        empty: 'Aucun article pour le moment. Revenez bientôt!',
        readMore: 'Lire la suite',
        backToBlog: 'Retour au blogue',
        share: 'Partager',
        notFound: 'Article introuvable',
        ctaTitle: 'Prêt à chouchouter votre toutou?',
        categories: {
          wellness: 'Bien-être',
          grooming: 'Conseils de toilettage',
          seasonal: 'Conseils saisonniers',
          community: 'Communauté'
        }
      },
      gallery: {
        liveFeed: 'Fil en direct',
        noPosts: 'Aucune publication disponible',
        hint: 'Faites défiler dans le téléphone pour parcourir les publications',
        viewOnInstagram: 'Voir sur Instagram',
        share: 'Partager'
      }
    }
  },
  en: {
    translation: {
      meta: {
        title: 'Casapooch — Luxury Dog Grooming in Montreal',
        description: 'Casapooch is a luxury dog grooming and wellness salon in the heart of Montreal’s Mile-Ex. Your Pooch, Our Passion.',
        locale: 'en_CA'
      },
      pageTitles: {
        about: 'About',
        services: 'Our Services',
        blog: 'CP Report',
        events: 'Events',
        book: 'Book',
        contact: 'Contact',
        gallery: 'Gallery',
        admin: 'Admin'
      },
      pageDescriptions: {
        about: 'Discover the story of Casapooch, founded by Jessica Amber Rossi and Pasqualino Dachille and inspired by their dogs Hunter and Brio.',
        services: 'Signature breed cuts, full grooming, bath & touch-ups, nail care: discover our luxury dog grooming services in Montreal.',
        blog: 'Grooming tips, wellness advice and news from the Casapooch community.',
        events: 'Events, workshops and meetups for dog lovers at Casapooch in Montreal.',
        book: 'Book your dog’s grooming appointment online at Casapooch in Montreal.',
        contact: 'Contact Casapooch: 70 Rue Jean-Talon O, Montreal. Open Tuesday to Saturday, 9 a.m. to 6 p.m.',
        gallery: 'See Casapooch’s latest transformations on Instagram.'
      },
      nav: {
        home: 'Home',
        about: 'About',
        services: 'Services',
        gallery: 'Gallery',
        blog: 'CP Report',
        events: 'Events',
        book: 'Book',
        contact: 'Contact',
        bookNow: 'Book Now',
        langToggle: 'Passer au français',
        openMenu: 'Open menu',
        closeMenu: 'Close menu'
      },
      home: {
        heroTitle: 'Your Pooch, Our Passion',
        heroSubtitle: 'Luxury grooming and wellness in the heart of Montreal',
        heroCta: 'Book Your Visit',
        servicesLabel: 'Our Services',
        servicesTitle: 'Pamper Your Pup',
        services: {
          bath: { title: 'Bath & Brush', desc: 'Hypoallergenic spa-grade formulas' },
          styling: { title: 'Styling & Cuts', desc: 'Breed-specific precision trims' },
          wellness: { title: 'Wellness Add-Ons', desc: 'Complete paw & coat care' },
          seasonal: { title: 'Seasonal Care', desc: 'Winter & summer coat management' }
        },
        viewAll: 'View All Services',
        storyLabel: 'Our Story',
        storyTitle: 'Where Expertise Meets Affection',
        storyText: 'Founded by Jessica Amber Rossi and Pasqualino Dachille, Casapooch was inspired by their beloved pups, Hunter and Brio. Every grooming session is tailored with precision, patience, and pure affection.',
        learnMore: 'Learn More About Us',
        reviewsLabel: 'Reviews',
        reviewsTitle: 'What Our Clients Say',
        reviewsMeta: '{{rating}} out of 5 — {{count}} reviews on Google',
        teamLabel: 'The Team',
        teamTitle: 'Meet the Founders',
        teamSubtitle: 'Jessica & Pasqualino with Hunter & Brio',
        readStory: 'Read Our Full Story',
        ctaTitle: 'Ready to Pamper Your Pooch?',
        ctaText: 'Book your appointment and give your furry friend the luxury spa experience they deserve.',
        ctaButton: 'Book Appointment',
        alts: {
          jessica: 'Jessica Amber Rossi - Main Founder',
          together: 'Jessica and Pasqualino at Casapooch',
          brio: 'Jessica, Pasqualino with Brio',
          hunter: 'Jessica, Pasqualino with Hunter'
        }
      },
      transformations: {
        label: 'Transformations',
        title: 'See The Magic',
        before: 'Before',
        after: 'After',
        altBefore: '{{name}} before',
        altAfter: '{{name}} after'
      },
      instagram: {
        label: 'Follow Us',
        title: '@lecasapooch',
        postAlt: 'Instagram post'
      },
      servicesPage: {
        overline: 'Our Services',
        title1: 'Luxury Grooming',
        title2: '& Wellness',
        subtitle: 'From breed-specific styling to complete wellness care, discover our signature services designed to pamper your pooch with expertise and affection.',
        ctaTitle: 'Ready to Book?',
        ctaText: 'Give your pooch the luxury spa experience they deserve. Reserve your appointment today.'
      },
      about: {
        overline: 'About Casapooch',
        title: 'Where Expertise Meets Affection',
        mainFounder: 'Main Founder',
        coFounder: 'Co-Founder',
        inspiration: 'The Inspiration',
        jessica: [
          'Jessica is the heart and soul of Casapooch. A passionate dog groomer with years of experience, she founded Casapooch with a simple belief: every dog deserves to feel pampered, loved, and beautiful.',
          'As a dedicated mother to Hunter and Brio, Jessica brings that same maternal care and attention to every pup that walks through our doors. Her expertise in breed-specific styling and gentle approach has made Casapooch Montreal’s most trusted luxury grooming destination.',
          'From nervous rescues to pampered show dogs, Jessica treats each grooming session as an opportunity to create a bond of trust and transform your pooch with precision, patience, and pure affection.'
        ],
        pasqualino: [
          'Pasqualino is the co-founder of Casapooch and the visionary behind Casanova Barber & Salon. His entrepreneurial spirit and commitment to excellence complement Jessica’s grooming expertise perfectly.',
          'As father to Hunter and Brio and husband to Jessica, Pasqualino brings business acumen and a shared passion for creating spaces where both people and pets feel valued and cared for. His experience in the hospitality and grooming industry helps ensure that every client experience at Casapooch is seamless and luxurious.',
          'Together, Jessica and Pasqualino have created more than a grooming salon—they’ve built a community where Montreal’s dog lovers know their pups will receive the very best care, inspired by the love they have for Hunter and Brio.'
        ],
        dogs: [
          'Hunter, a gentle and loyal Golden Retriever, is the calm soul of the family. His sweet nature and patience inspired the warm, stress-free atmosphere at Casapooch. Every dog that visits is treated with the same tenderness Hunter receives at home.',
          'Brio, a spirited and playful Goldendoodle, brings the energy and joy. His curly coat and love for grooming sessions sparked the idea for Casapooch in the first place. Brio reminds us every day that grooming should be a fun, positive experience for every pup.'
        ],
        community: 'Community Connection',
        rootedTitle: 'Rooted in Montreal',
        communityContent: 'Located in the heart of Montreal’s Mile-Ex and Little Italy corridors, Casapooch is more than a grooming salon—it’s a community hub for dog lovers. We’re proud to serve families from across Montreal, including those who frequent nearby Parc Jarry and Parc Dante with their four-legged friends.',
        values: {
          love: { title: 'Love & Care', desc: 'Every dog is treated with the same affection and attention we give to Hunter and Brio.' },
          luxury: { title: 'Luxury Experience', desc: 'Spa-grade products, calming environment, and boutique-level service for your pooch.' },
          precision: { title: 'Expert Precision', desc: 'Breed-specific styling and grooming techniques perfected over years of experience.' }
        },
        alts: {
          jessica: 'Jessica Amber Rossi - Main Founder of Casapooch',
          founders: 'Jessica Amber Rossi and Pasqualino Dachille - Founders of Casapooch',
          dogs: 'Hunter and Brio with Jessica and Pasqualino at Casapooch'
        }
      },
      testimonials: {
        reviews: [
          { text: 'Best groomers in Montreal! My rescue girl Hazel felt calm and happy.', author: 'Kseniia M.' },
          { text: 'Great care for our 14-year-old terrier — amazing patience and skill.', author: 'Mrs Meadys' },
          { text: 'Our pup always comes home looking and feeling fantastic!', author: 'Sarah L.' }
        ]
      },
      booking: {
        overline: 'Book Appointment',
        title: 'Reserve Your Dog’s Spa Day',
        subtitle: 'Book your appointment right here',
        openInNew: 'Open Booking in New Tab',
        systemTitle: 'MoeGo Booking System',
        iframeTitle: 'Online booking',
        expectTitle: 'What to Expect',
        steps: {
          call: { title: 'Confirmation Call', desc: 'We’ll call to confirm your appointment and discuss your pup’s needs.' },
          spa: { title: 'Spa Experience', desc: 'Relax while we pamper your pooch with luxury grooming and care.' },
          happy: { title: 'Happy Pup', desc: 'Pick up your beautifully groomed, happy, and healthy dog!' }
        },
        floatingTitle: 'Book Your Spa Day',
        floatingSubtitle: 'Reserve your appointment below',
        floatingOpen: 'Book an appointment',
        floatingClose: 'Close'
      },
      contact: {
        overline: 'Contact Us',
        title: 'Visit Us',
        subtitle: 'We’d love to hear from you. Visit us in Mile-Ex or get in touch online.',
        getInTouch: 'Get In Touch',
        addressLabel: 'Address',
        phoneLabel: 'Phone',
        emailLabel: 'Email',
        address: '70 Rue Jean-Talon O, Montreal QC H2R 2W7',
        phone: '514-272-9016',
        email: 'woof@lecasapooch.com',
        hours: 'Hours',
        hoursSchedule: 'Tue – Sat: 9 a.m.–6 p.m.',
        closed: 'Closed Sun & Mon',
        mapTitle: 'Casapooch Location',
        form: {
          title: 'Get In Touch',
          name: 'Name',
          email: 'Email',
          message: 'Message',
          send: 'Send Message',
          success: 'Thank you! We’ll be in touch soon.',
          error: 'Something went wrong. Please try again.'
        }
      },
      footer: {
        tagline: 'Your Pooch, Our Passion.',
        quickLinks: 'Quick Links',
        contact: 'Contact',
        addressLine1: '70 Rue Jean-Talon O',
        addressLine2: 'Montreal QC H2R 2W7',
        rights: '© 2026 Casapooch. All rights reserved.'
      },
      blog: {
        title: 'Blog & Updates',
        heading: 'Tips, Stories & Updates',
        subtitle: 'Expert grooming advice, wellness tips, and updates from the Casapooch community.',
        empty: 'No blog posts yet. Check back soon!',
        readMore: 'Read More',
        backToBlog: 'Back to Blog',
        share: 'Share',
        notFound: 'Post not found',
        ctaTitle: 'Ready to Pamper Your Pooch?',
        categories: {
          wellness: 'Wellness',
          grooming: 'Grooming Tips',
          seasonal: 'Seasonal Advice',
          community: 'Community'
        }
      },
      gallery: {
        liveFeed: 'Live Feed',
        noPosts: 'No posts available',
        hint: 'Scroll inside the phone to browse posts',
        viewOnInstagram: 'View on Instagram',
        share: 'Share'
      },
      admin: {
        title: 'Admin Panel',
        login: 'Login',
        logout: 'Logout',
        username: 'Username',
        password: 'Password',
        createPost: 'Create New Post',
        editPost: 'Edit Post',
        deletePost: 'Delete Post',
        posts: 'Blog Posts',
        save: 'Save',
        cancel: 'Cancel'
      }
    }
  }
};

const readSavedLang = () => {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    return saved === 'en' || saved === 'fr' ? saved : null;
  } catch {
    return null;
  }
};

const initialLang = readSavedLang() || 'fr';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLang,
    fallbackLng: 'en',
    supportedLngs: ['fr', 'en'],
    interpolation: {
      escapeValue: false
    }
  });

document.documentElement.lang = initialLang;

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
  try {
    window.localStorage.setItem(STORAGE_KEY, lng);
  } catch {
    // storage unavailable (private mode) — language still switches for the session
  }
});

export default i18n;
